import { H6, LI, UL } from "../../../../AbstractElements";
import { BlogByLearning, HitsLearning } from "../../../../Constant";
import { BlogDetailsProp } from "../../../../Type/Learning";

const BlogDetails = ({ text }: BlogDetailsProp) => {
  return (
    <div className="blog-details-main">
      <UL className="blog-social simple-list d-flex flex-row justify-content-center">
        <LI className="rounded-0">9 April 2023</LI>
        <LI>{BlogByLearning}Admin</LI>
        <LI>0 {HitsLearning}</LI>
      </UL>
      <hr />
      <H6 className="blog-bottom-details">{text}</H6>
    </div>
  );
};

export default BlogDetails;
